import { render, staticRenderFns } from "./CompleteOrder.vue?vue&type=template&id=6dcb80d2&"
import script from "./CompleteOrder.vue?vue&type=script&lang=js&"
export * from "./CompleteOrder.vue?vue&type=script&lang=js&"
import style0 from "./CompleteOrder.vue?vue&type=style&index=0&id=6dcb80d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports